import React from "react";
import "./AstroVastu.css";
import vastuBanner from "../assets/zodiac/Aquarius.jpg";
import BlogSlider from "../components/BlogSlider";
import ServiceProduts from "../components/ServiceProduts";
import ContactForm from "../components/ContactForm"; 

const CareerPrediction = () => {
  return (
    <div className="services-page">
      {/* Left Side - 67% Text Content */}
      <div className="services-content">
       


 <h1>Career Astrology: Discover Your Professional Destiny</h1>
    
    <div class="highlight-box">
        <p>Career astrology reveals your vocational potential by analyzing planetary positions at your birth. Our precise career prediction by date of birth helps you understand your innate talents, ideal professions, and optimal timing for career growth.</p>
    </div>

    <h2>How Birth Chart Analysis Guides Career Choices</h2>
    
    <p>Your natal chart serves as a cosmic blueprint for career success. Astrologers specializing in career prediction by date of birth examine three crucial components:</p>
    
    <div class="planet-influence">
        <div class="planet-card">
            <h3>The 10th House (Career House)</h3>
            <p>This pivotal house reveals your professional calling, public reputation, and ultimate career achievements. Planetary placements here indicate your vocational strengths.</p>
        </div>
        <div class="planet-card">
            <h3>Midheaven (MC)</h3>
            <p>The highest point in your chart shows your career aspirations and the legacy you wish to create through your professional life.</p>
        </div>
        <div class="planet-card">
            <h3>Planetary Aspects</h3>
            <p>Benefic connections between planets create career opportunities, while challenging aspects indicate areas requiring extra effort.</p>
        </div>
    </div>

    <h2>Planetary Influences on Career Paths</h2>
    
    <table class="zodiac-table">
        <tr>
            <th>Planet</th>
            <th>Career Influence</th>
            <th>Best Professions</th>
        </tr>
        <tr>
            <td>Sun</td>
            <td>Leadership, creativity, vitality</td>
            <td>Management, government, entertainment</td>
        </tr>
        <tr>
            <td>Moon</td>
            <td>Emotional intelligence, nurturing</td>
            <td>Healthcare, hospitality, psychology</td>
        </tr>
        <tr>
            <td>Mercury</td>
            <td>Communication, analytical skills</td>
            <td>Writing, teaching, technology</td>
        </tr>
        <tr>
            <td>Venus</td>
            <td>Aesthetics, harmony, diplomacy</td>
            <td>Arts, design, counseling</td>
        </tr>
        <tr>
            <td>Mars</td>
            <td>Energy, courage, initiative</td>
            <td>Sports, military, engineering</td>
        </tr>
        <tr>
            <td>Jupiter</td>
            <td>Expansion, wisdom, luck</td>
            <td>Law, education, philosophy</td>
        </tr>
        <tr>
            <td>Saturn</td>
            <td>Discipline, structure, endurance</td>
            <td>Science, architecture, administration</td>
        </tr>
    </table>

    <h2>Zodiac Signs and Career Compatibility</h2>
    
    <p>Each zodiac sign possesses unique professional strengths. Here's how your sun sign influences your career path:</p>
    
    <h3>Aries (March 21 - April 19)</h3>
    <p>Natural entrepreneurs and pioneers excel in competitive fields, startups, and leadership roles. Their courage and initiative make them excellent emergency responders and athletes.</p>
    
    <h3>Taurus (April 20 - May 20)</h3>
    <p>With exceptional perseverance and practical skills, Taureans thrive in banking, real estate, culinary arts, and financial management.</p>
    
    <h3>Gemini (May 21 - June 20)</h3>
    <p>Masters of communication flourish in media, sales, writing, and teaching. Their adaptability suits fast-paced, information-driven careers.</p>
    
    <h3>Cancer (June 21 - July 22)</h3>
    <p>Nurturing personalities succeed in healthcare, education, hospitality, and social work where emotional intelligence is valued.</p>
    
    <h3>Leo (July 23 - August 22)</h3>
    <p>Charismatic leaders dominate entertainment, management, and creative fields. Their confidence shines in performance-based careers.</p>
    
    <h3>Virgo (August 23 - September 22)</h3>
    <p>Analytical perfectionists excel in research, editing, healthcare, and technical fields requiring precision and attention to detail.</p>
    
    <h3>Libra (September 23 - October 22)</h3>
    <p>Diplomatic peacemakers thrive in law, counseling, design, and human resources where balance and fairness are essential.</p>
    
    <h3>Scorpio (October 23 - November 21)</h3>
    <p>Intense investigators succeed in psychology, detective work, surgery, and research fields requiring depth and transformation.</p>
    
    <h3>Sagittarius (November 22 - December 21)</h3>
    <p>Adventurous philosophers flourish in travel, publishing, education, and careers offering freedom and intellectual stimulation.</p>
    
    <h3>Capricorn (December 22 - January 19)</h3>
    <p>Ambitious strategists rise to executive positions in business, politics, and engineering through disciplined career planning.</p>
    
    <h3>Aquarius (January 20 - February 18)</h3>
    <p>Innovative humanitarians excel in technology, social reform, science, and unconventional careers that allow creative problem-solving.</p>
    
    <h3>Pisces (February 19 - March 20)</h3>
    <p>Compassionate visionaries thrive in arts, healing professions, spirituality, and careers requiring imagination and empathy.</p>

    <div class="highlight-box">
        <p>Remember: While astrology reveals your natural inclinations, your free will and efforts ultimately shape your career destiny. As the ancient wisdom states, "Fortune favors the bold" - your actions combined with cosmic guidance create professional success.</p>
    </div>
    
    <p>Apart from the celestial aspects regarding wealth and astrology, in Bhagwad Gita, Chapter 2, Verse 47, Lord Krishna tells Arjuna about the relevance of Karma as follows-</p>
        {/* FAQs */}
        <div className="faq-section">
          <h3>Frequently Asked Questions</h3>
          <div className="faq"><h4>What is Astro Vastu?</h4><p>Astro Vastu combines Vastu Shastra with astrology to bring personalized solutions based on your birth chart.</p></div>
          <div className="faq"><h4>Can this service be done remotely?</h4><p>Yes, we offer remote consultations through video calls and shared floor plans.</p></div>
          <div className="faq"><h4>How do I choose a gemstone?</h4><p>We analyze your birth chart and planetary positions to recommend suitable gemstones.</p></div>
          <div className="faq"><h4>What is the benefit of Rudraksha?</h4><p>Rudraksha beads help in spiritual growth and balancing chakras and energy fields.</p></div>
        </div>

        {/* Blog Slider */}
            <div className="recent-blogs">
                    
                     <BlogSlider />
            </div>

      </div>

      {/* Right Side - 33% Banner Image, Contact, Social, Buy */}
      <div className="sidebar">
        <div className="banner-image">
          <img src="/assets/profile/Jyotish_karam_profile.jpeg" alt="Astro Vastu Services Banner" />
        </div>

        <div className="social-follow">
          <h4>Follow Us</h4>
          <div className="social-icons">
            <a href="#"><i className="fab fa-facebook-f" /></a>
            <a href="#"><i className="fab fa-instagram" /></a>
            <a href="#"><i className="fab fa-twitter" /></a>
            <a href="#"><i className="fab fa-linkedin-in" /></a>
            <a href="#"><i className="fab fa-pinterest-p" /></a>
            <a href="#"><i className="fab fa-youtube" /></a>
          </div>
        </div>
          <ContactForm />
       
          <ServiceProduts />
        
      </div>
    </div>
  );
};

export default CareerPrediction;
